import { render } from "./index.vue?vue&type=template&id=be1ba71e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=be1ba71e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-be1ba71e"

export default script